export function isSafeRelativePath(url: string): boolean {
  if (url.length === 0) return false
  if (url[0] !== '/') return false
  if (url.startsWith('//')) return false
  if (url.includes('\\')) return false
  for (let i = 0; i < url.length; i++) {
    if (url.charCodeAt(i) < 0x20) return false
  }
  let decoded: string
  try {
    decoded = decodeURIComponent(url)
  } catch {
    return false // malformed percent-encoding
  }
  if (decoded.startsWith('//') || decoded.includes('\\')) return false
  return true
}
